import { useEffect } from "react";
import { Outlet, useLocation, useNavigationType } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

// পেজ বদলালে উপরে ফিরে যাওয়া (BrowserRouter নিজে করে না — তালিকার নিচ থেকে কার্ডে ঢুকলে নতুন পেজ মাঝখানে
// খুলত)। ব্রাউজারের back/forward-এ ছোঁয়া হয় না; ফিল্টার বদলালে (শুধু ?query) স্ক্রল যেমন ছিল তেমনই।
function ScrollToTop() {
  const { pathname } = useLocation();
  const type = useNavigationType();
  useEffect(() => {
    if (type !== "POP") window.scrollTo(0, 0);
  }, [pathname, type]);
  return null;
}

export default function Layout() {
  return (
    <div className="gallery-scope flex min-h-screen flex-col">
      <a
        href="#main"
        className="no-print sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-50 focus:rounded-lg focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground"
      >
        মূল অংশে যান
      </a>
      <ScrollToTop />
      <Header />
      <main id="main" className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
